import { createContext, useContext } from "react";

type AnnotationEditorSurface = {
  /**
   * Whether the editor sits on a dark surface. True by default, for the dark dialogs and cards over the canvas.
   * The annotation panel sets it to false today, and will set it from the app theme once the dark mode lands.
   */
  dark: boolean;

  /** True to fill the width of a resizable panel, instead of the fixed width of the dialogs */
  fillWidth?: boolean;
};

/** Where the annotation editor is shown, to adapt its style and size */
export const AnnotationEditorSurfaceContext =
  createContext<AnnotationEditorSurface>({ dark: true });

/** @returns true if the annotation editor fields should use their dark style */
export function useIsAnnotationEditorDark(): boolean {
  return useContext(AnnotationEditorSurfaceContext).dark;
}

/** @returns true if the annotation editor should fill the width of its container */
export function useIsAnnotationEditorFillWidth(): boolean {
  return !!useContext(AnnotationEditorSurfaceContext).fillWidth;
}
